<template>
  <div>
    <div class="row">
      <div class="col-8">
        <div v-if="this.data">
          <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
            "Müştəri xidməti tərəfindən iş başlanmışdır: " + data.createdBy
          }}</span>
        </div>
      </div>
    </div>
    <card v-if="this.data">
      <titles :text="$t('İşlər')"></titles>
      <hr width="100%" size="50" style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
      align="center">
      <el-form v-loading="loading">
        <div @dblclick="clickCard(item.id)" class="row" v-for="item in claims" :key="item.id">
          <div class="col-12">
            <claim-card :item="item" @refresh="getData" />
          </div>
        </div>
      </el-form>
    </card>
    <el-collapse v-loading="loading" value="1">
      <el-collapse-item name="1">
        <template #title>
          <div style="margin-left: 7px;"> 
            <i class="fa-solid fa-headphones-simple"></i>
            &nbsp;
            <span>{{ $t('Çağrı_mərkəzinin_qeydləri') }}</span>
          </div>
        </template>
        <accident-base :value="item"></accident-base>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-loading="loading" value="2">
      <el-collapse-item name="2">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-person-military-pointing"></i>
            &nbsp;
            <span>{{$t('Komissarın_qeydləri')}}</span>
          </div>
        </template>
        <accident-comm-base :value="comm"></accident-comm-base>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="3">
      <el-collapse-item name="3">
        <template #title>
          <div style="margin-left: 7px;">
          <i class="fa-solid fa-people-arrows-left-right"></i>
          &nbsp;
          <span>{{$t('İştirakçılar')}}</span>
          </div>
        </template>
        <card>
          <el-form v-loading="partloading">
            <div class="row">
              <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
                <div v-if="item.policyType === null || item.policyType === 1">
                  <participant-card :item="item"  :readonly="true"  @refresh="getParticipants"
                    @edit="editParticipant(item)" @delete="deleteParticipant" @report="reportParticipant(item)" />
                </div>
                <div v-else>
                  <other-participant-card :item="item"  @refresh="getParticipants"
                    @edit="editParticipant(item)" :readonly="true" @delete="deleteParticipant" @report="reportParticipant(item)" />
                </div>
              </div>
            </div>
          </el-form>
        </card>
      </el-collapse-item>
    </el-collapse>

    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
  </div>
</template>

<script>
import {
  GetAccident,
  GetCommData,
  GetParticipants,
  ClientServiceStart,
  GetAccidentsByStatus,
  DeleteParticipant,
} from "../../services/accident";
import Titles from "../components/Titles.vue";
import { DeleteClaim } from "../../services/claim";
import { GetClaimParticipants, LastAccidentStatus } from "../../services/common";
import Participant from "../components/Participant.vue";
import ParticipantCard from "../components/ParticipantCard.vue";
import ClaimCard from "../components/ClaimCard.vue";
import AccidentBase from "../components/AccidentBase.vue";
import AccidentCommBase from "../components/AccidentCommBase.vue";
import ReportParticipant from "../components/ReportParticipant.vue";
import OtherParticipantCard from "../components/OtherParticipantCard.vue";
export default {
  props: {
    id: [String, Number],
  },
  components: {
    Titles,
    Participant,
    ClaimCard,
    AccidentBase,
    AccidentCommBase,
    ParticipantCard,
    ReportParticipant,
    OtherParticipantCard
  },
  data() {
    return {
      loading: false,
      commloading: false,
      partloading: false,
      item: {},
      comm: {},
      data: {},
      participants: [],
      claims: {},
      uid: this.$store.state.user.id,
      rejectVisible: false
    };
  },
  computed: {

    isFormDisabled() {
      return (this.accidentStatus >= 11 && this.accidentStatus <= 13) || this.accidentStatus >= 30;
    },

  },
  methods: {
    clickCard(id) {
      this.$router.push({
        path: "../claim/" + id,
      });
    },
    openDialog() {
      this.rejectVisible = true;
    },

    newClaim() {
      this.$refs["claim"].new(this.comm.accidentId);
    },
    newParticipant() {
      this.$refs["participant"].new(this.comm.accidentId);
    },
    map() {
      this.$refs["mapcontrol"].show(this.comm.lat, this.comm.lng);
    },
    lastAccidentStatus() {
      LastAccidentStatus(this.id).then((response) => {
        if (response) {
          this.accidentStatus = response.data;
        } else {
        }
      });
    },
    onStart() {
      this.$confirm("Hadisə üzrə iş başlandı?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "info",
      }).then(() => {
        this.loading = true;
        ClientServiceStart(this.id, this.uid).then((response) => {
          this.loading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
              this.getDataByStatus();
            }
          } else {
          }
        });
      });
    },

    getCommData() {
      this.commloading = true;
      GetCommData(this.id).then((response) => {
        this.commloading = false;
        if (response.data) {
          this.comm = response.data.data?.[0]
        } else {
        }
      });
    },

    getData() {
      this.loading = true;
      GetAccident(this.id).then((response) => {
        this.loading = false;
        if (response.data) {
          this.item = response.data.data?.[0]
          
          this.getCommData();
          this.getParticipants();
          this.getDataByStatus();
          this.getClaimParticipants();
        } else {
        }
      });
    },
    getDataByStatus() {
      this.loading = true;
      GetAccidentsByStatus(this.id, 0, 40, this.uid).then((response) => {
        this.loading = false;
        if (response.data) {
          this.data = response.data.data?.[0];
        } else {
          this.data = null;
        }
      });
    },
    getParticipants() {
      this.partloading = true;
      GetParticipants(this.id).then((response) => {
        this.partloading = false;
        if (response.data) {
          this.participants = response.data.data;
        }
      });
    },
    getClaimParticipants() {
      this.partloading = true;
      GetClaimParticipants(this.id).then((response) => {
        this.partloading = false;
        if (response.data) {
          this.claims = response.data.data;
        }
      });
    },

    editParticipant(item) {
      let shouldEdit = item.createUser === this.uid;
      this.$refs["participant"].edit(item.id, !shouldEdit);
    },

    reportParticipant(item) {
      let shouldEdit = item.createUser === this.uid;
      this.$refs["report"].edit(item.id, item.accidentId, item.createUserId,!shouldEdit);
    },

    deleteClaim(id) {
      this.$confirm("İş ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "error",
      })
        .then(() => {
          this.loading = true;
          DeleteClaim(id, this.uid).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "İş ləğv olundu",
                });
                this.getClaimParticipants();
              }
            } else {
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },
    deleteParticipant(id) {
      this.$confirm("İştirakçı ləğv olunsun?", "Təstiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "error",
      })
        .then(() => {
          this.partloading = true;
          DeleteParticipant(id, this.uid).then((response) => {
            this.partloading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Ləğv olundu",
                });
                this.getParticipants();
              }
            } else {
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },
    handleUser() {
      this.$refs["user"].edit(this.item);
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>